var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { NotiService } from '@app/noti.service';
import { Router } from '@angular/router';
var ContactDpaComponent = /** @class */ (function () {
    function ContactDpaComponent(fb, util, apiService, notiService, router) {
        this.fb = fb;
        this.util = util;
        this.apiService = apiService;
        this.notiService = notiService;
        this.router = router;
        this.dpa_casestatusid = "";
        this.dpa_casechannelid = "";
        this.isComplain = false;
        this.submitted = false;
        this.captchaMatch = false;
        this.lang = "th";
        this.menuEnabled = false;
        this.form = this.fb.group({
            contactid: "",
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            dpa_idcard: ['', this.idCardValidator],
            telephone1: ['', Validators.required],
            emailaddress1: ['', this.emailValidator],
            dpa_contact_homeno: '',
            dpa_contact_moo: "",
            dpa_contact_street: "",
            dpa_contact_subdistict: "",
            dpa_contact_distict: "",
            dpa_contact_province: "",
            dpa_contact_postcode: "",
            dpa_contact_subdistictname: "",
            dpa_contact_distictname: "",
            dpa_contact_provincname: "",
            dpa_contact_postcodename: "",
            incidentid: "",
            customerid: "",
            dpa_casetypeid: ['', Validators.required],
            dpa_casesubtypeid: ['', Validators.required],
            dpa_casesubtypedetailid: ['', Validators.required],
            dpa_casestatusid: '',
            dpa_casechannelid: '',
            description: ['', Validators.required],
            IdCard: ''
        });
    }
    ContactDpaComponent.prototype.ngOnDestroy = function () {
        if (this.notiSubscription) {
            this.notiSubscription.unsubscribe();
        }
    };
    ContactDpaComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            function matchCustom(params, data) {
                if ($.trim(params.term) === '') {
                    return data;
                }
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (params.term.length > 1) {
                    var cris = params.term.split(" ");
                    var found = true;
                    for (var i = 0; i < cris.length; i++) {
                        if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
                            found = false;
                            return null;
                        }
                    }
                    if (found) {
                        return data;
                    }
                }
                return null;
            }
            var thisTs, config, crisisConfig, isCrisis, menuList, thisMenu;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        config = _a.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            isCrisis = true;
                        }
                        else {
                            isCrisis = false;
                        }
                        5;
                        return [4 /*yield*/, this.apiService.get("master", "customerPortalMenuSetting")];
                    case 2:
                        menuList = _a.sent();
                        thisMenu = this.util.getMenuObj(menuList, "02", isCrisis);
                        if (!thisMenu.show) {
                            this.util.ShowWaiting(false);
                            setTimeout(function () {
                                _this.router.navigate(["mainmenu/index"]);
                            }, 500);
                            return [2 /*return*/];
                        }
                        else {
                            this.menuEnabled = true;
                        }
                        // let tmpLang = this.util.GetCurrentLang()
                        // this.lang = tmpLang.substring(0,2)
                        // this.util.SetLanguage(tmpLang)
                        this.util.InitValidation();
                        this.captcha = new Captcha($('#canvas'), {
                            length: 6
                        });
                        if (this.lang == "th") {
                            $(".select2-en").hide();
                            $(".select2-th").show();
                        }
                        else {
                            $(".select2-th").hide();
                            $(".select2-en").show();
                        }
                        this.notiSubscription = this.notiService.message.subscribe(function (_lang) {
                            _this.lang = _lang;
                            if (_this.lang == "th") {
                                $(".select2-en").hide();
                                $(".select2-th").show();
                            }
                            else {
                                $(".select2-th").hide();
                                $(".select2-en").show();
                            }
                            if (_this.contactData != null && _this.contactData.length > 0) {
                                $(".select2").val(_this.contactData[0].dpa_contact_subdistict + "|" + _this.contactData[0].dpa_contact_distict + "|" + _this.contactData[0].dpa_contact_province + "|" + _this.contactData[0].dpa_contact_postcode + "|" + _this.contactData[0].dpa_contact_country).trigger('change');
                            }
                            //this.bindAddress(this.lang)
                        });
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        $('.select2th').select2({
                            matcher: matchCustom,
                            placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
                        });
                        $('.select2en').select2({
                            matcher: matchCustom,
                            placeholder: "Please select your address."
                        });
                        $(".select2").on("change", function (e) {
                            thisTs.addressChange(e.target.value);
                        });
                        this.initDropdown();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactDpaComponent.prototype.initDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.cookieData.contactid != null && this.cookieData.contactid != "") {
                    Observable.forkJoin(this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseChannel"), this.apiService.getMasterAddress(), this.apiService.get("crmservice", "contact", "contactid=" + this.cookieData.contactid)).subscribe(function (data) {
                        _this.caseTypeList = data[0];
                        _this.subTypeTmpList = data[1];
                        _this.subTypeDetailTmpList = data[2];
                        _this.caseStatusList = data[3];
                        _this.caseChannelList = data[4];
                        _this.combinedAddressList = data[5];
                        _this.contactData = data[6];
                        _this.setAddressEn();
                        if (_this.contactData != null && _this.contactData.length > 0) {
                            _this.mapDataToForm(_this.contactData[0]);
                            $(".select2").val(_this.contactData[0].dpa_contact_subdistict + "|" + _this.contactData[0].dpa_contact_distict + "|" + _this.contactData[0].dpa_contact_province + "|" + _this.contactData[0].dpa_contact_postcode + "|" + _this.contactData[0].dpa_contact_country).trigger('change');
                        }
                        _this.util.ShowWaiting(false);
                    }, function (err) { return console.error(err); });
                }
                else {
                    Observable.forkJoin(this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseChannel"), this.apiService.getMasterAddress()).subscribe(function (data) {
                        _this.util.ShowWaiting(false);
                        _this.caseTypeList = data[0];
                        _this.subTypeTmpList = data[1];
                        _this.subTypeDetailTmpList = data[2];
                        _this.caseStatusList = data[3];
                        _this.caseChannelList = data[4];
                        _this.combinedAddressList = data[5];
                        _this.setAddressEn();
                    }, function (err) { return console.error(err); });
                }
                return [2 /*return*/];
            });
        });
    };
    ContactDpaComponent.prototype.setAddressEn = function () {
        if (this.combinedAddressList != null && this.combinedAddressList.length > 0) {
            this.combinedAddressListEn = this.combinedAddressList.slice().sort(function (a, b) {
                if (a.text_eng < b.text_eng) {
                    return -1;
                }
                if (a.text_eng > b.text_eng) {
                    return 1;
                }
                return 0;
            });
        }
    };
    ContactDpaComponent.prototype.addressChange = function (value) {
        var selected = this.combinedAddressList.filter(function (a) { return a.id == value; });
        if (selected != null && selected.length > 0) {
            var values = selected[0].id.split("|");
            var texts = void 0;
            if (this.lang == "th") {
                texts = selected[0].text.split(" | ");
            }
            else {
                texts = selected[0].text_eng.split(" | ");
            }
            this.formControl["dpa_contact_subdistict"].setValue(values[0]);
            this.formControl["dpa_contact_distict"].setValue(values[1]);
            this.formControl["dpa_contact_province"].setValue(values[2]);
            this.formControl["dpa_contact_postcode"].setValue(values[3]);
            this.formControl["dpa_contact_subdistictname"].setValue(texts[0]);
            this.formControl["dpa_contact_distictname"].setValue(texts[1]);
            this.formControl["dpa_contact_provincname"].setValue(texts[2]);
            this.formControl["dpa_contact_postcodename"].setValue(texts[3]);
        }
        else {
            this.formControl["dpa_contact_subdistict"].setValue("");
            this.formControl["dpa_contact_distict"].setValue("");
            this.formControl["dpa_contact_province"].setValue("");
            this.formControl["dpa_contact_postcode"].setValue("");
            this.formControl["dpa_contact_subdistictname"].setValue("");
            this.formControl["dpa_contact_distictname"].setValue("");
            this.formControl["dpa_contact_provincname"].setValue("");
            this.formControl["dpa_contact_postcodename"].setValue("");
        }
    };
    ContactDpaComponent.prototype.refreshCaptcha = function () {
        this.captcha.refresh();
    };
    ContactDpaComponent.prototype.isValidCaptcha = function () {
        //var a = this.captcha.getCode()
        this.captchaMatch = this.captcha.valid($('input[name="code"]').val());
        return this.captchaMatch;
    };
    ContactDpaComponent.prototype.clear = function () {
        this.form.reset();
        this.formControl["dpa_contact_subdistictname"].setValue("");
        this.formControl["dpa_contact_distictname"].setValue("");
        this.formControl["dpa_contact_provincname"].setValue("");
        this.formControl["dpa_contact_postcodename"].setValue("");
        this.caseSubTypeList = [];
        this.caseSubTypeDetailList = [];
        $('input[name="code"]').val("");
        try {
            $(".select2").val("").trigger("change");
        }
        catch (e) {
        }
        this.refreshCaptcha();
        this.submitted = false;
    };
    ContactDpaComponent.prototype.emailValidator = function (control) {
        if (control.value) {
            var matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? null : { 'invalidEmail': true };
        }
        else {
            return null;
        }
    };
    Object.defineProperty(ContactDpaComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactDpaComponent.prototype, "email", {
        get: function () {
            return this.form.value.emailaddress1.trim();
        },
        enumerable: true,
        configurable: true
    });
    ContactDpaComponent.prototype.onCaseTypeChange = function () {
        var _this = this;
        var selectedCase = this.caseTypeList.filter(function (c) {
            return c.dpa_casetypeid == _this.form.get("dpa_casetypeid").value;
        });
        if (selectedCase != null && selectedCase.length > 0) {
            this.isComplain = selectedCase[0].dpa_name == "ร้องเรียน";
        }
        else {
            this.isComplain = false;
        }
        this.caseSubTypeList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.form.get("dpa_casetypeid").value; });
        this.form.get("dpa_casesubtypeid").setValue("");
        this.onCaseSubTypeChange();
    };
    ContactDpaComponent.prototype.onCaseSubTypeChange = function () {
        var _this = this;
        this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter(function (s) { return s.dpa_casesubtypeid === _this.form.get("dpa_casesubtypeid").value; });
        this.form.get("dpa_casesubtypedetailid").setValue("");
    };
    ContactDpaComponent.prototype.sendToDPA = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var selectedSubTypeDetail, channel, sendLogReq, sendLogRes, req, res, status_1, caseId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        this.isValidCaptcha();
                        if (!(this.form.valid && this.captchaMatch && this.isComplainFilled())) return [3 /*break*/, 8];
                        this.util.ShowWaiting(true);
                        selectedSubTypeDetail = this.caseSubTypeDetailList.filter(function (f) {
                            return f.dpa_casesubtypedetailid == _this.formControl["dpa_casesubtypedetailid"].value;
                        });
                        channel = this.caseChannelList.filter(function (ch) {
                            return ch.dpa_code == "02";
                        });
                        if (!selectedSubTypeDetail[0].dpa_issendemail) return [3 /*break*/, 5];
                        sendLogReq = {
                            dpa_name: selectedSubTypeDetail[0].dpa_emailaddress
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "logSendEmail", sendLogReq)];
                    case 1:
                        sendLogRes = _a.sent();
                        if (!this.util.isSuccessResponse(sendLogRes)) return [3 /*break*/, 3];
                        req = {
                            //contactid: customerId,
                            dpa_name: "แจ้งเรื่องร้องเรียน",
                            dpa_description: this.formControl["description"].value,
                            dpa_emailaddress: selectedSubTypeDetail[0].dpa_emailaddress,
                            template: "",
                            dpa_casesubtypedetailid: selectedSubTypeDetail[0].dpa_casesubtypedetailid,
                            logsendmailid: sendLogRes.dpa_sendemailid,
                            dpa_callby: 2,
                            contact_firstname: this.formControl["firstname"].value,
                            contact_lastname: this.formControl["lastname"].value,
                            contact_homeno: this.formControl["dpa_contact_homeno"].value,
                            contact_moo: this.formControl["dpa_contact_moo"].value,
                            contact_street: this.formControl["dpa_contact_street"].value,
                            contact_subdistrictname: this.formControl["dpa_contact_subdistictname"].value,
                            contact_districtname: this.formControl["dpa_contact_distictname"].value,
                            contact_provincename: this.formControl["dpa_contact_provincname"].value,
                            contact_postcodename: this.formControl["dpa_contact_postcodename"].value,
                            contact_telephone: this.formControl["telephone1"].value,
                            contact_emailaddress: this.formControl["emailaddress1"].value,
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendEmail", req)];
                    case 2:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            this.clear();
                            this.util.SuccessDialog("บันทึกข้อมูลสำเร็จ");
                        }
                        else {
                            this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        this.form.controls["customerid"].setValue(null);
                        this.form.controls["contactid"].setValue(null);
                        status_1 = this.caseStatusList.filter(function (c) {
                            return c.dpa_name.toUpperCase() == "NEW";
                        });
                        if (status_1 == null || status_1.length == 0) {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog("ไม่สามารถกำหนดค่าสถานะได้ กรุณาติดต่อเจ้าหน้าที่");
                            return [2 /*return*/];
                        }
                        // let channel: any = this.caseChannelList.filter((c: any) => {
                        //   return c.dpa_name.toUpperCase() == "WEBSITE"
                        // })
                        if (channel == null || channel.length == 0) {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog("ไม่สามารถกำหนดค่าช่องทางได้ กรุณาติดต่อเจ้าหน้าที่");
                            return [2 /*return*/];
                        }
                        this.form.controls["dpa_casestatusid"].setValue(status_1[0].dpa_casestatusid);
                        this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid);
                        return [4 /*yield*/, this.createCase()];
                    case 6:
                        caseId = _a.sent();
                        if (caseId == null) {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่");
                            return [2 /*return*/];
                        }
                        else {
                            // if (customerId != null && caseId != null) {
                            this.clear();
                            this.util.SuccessDialog("บันทึกข้อมูลสำเร็จ");
                        }
                        _a.label = 7;
                    case 7:
                        // else {
                        //   this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ")
                        // }
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 9];
                    case 8:
                        this.util.WarningDialog("กรุณากรอกข้อมูลให้ครบ");
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ContactDpaComponent.prototype.isComplainFilled = function () {
        if (!this.isComplain) {
            return true;
        }
        else {
            return (this.formControl.dpa_idcard.value != null && this.formControl.dpa_idcard.value.trim().length != 0)
                && (this.formControl.dpa_contact_homeno.value != null && this.formControl.dpa_contact_homeno.value.trim().length != 0)
                && (this.formControl.dpa_contact_street.value != null && this.formControl.dpa_contact_street.value.trim().length != 0)
                && (this.formControl.dpa_contact_subdistict.value != null && this.formControl.dpa_contact_subdistict.value.trim().length != 0);
        }
    };
    ContactDpaComponent.prototype.createCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            FirstName: this.formControl["firstname"].value,
                            LastName: this.formControl["lastname"].value,
                            PhoneNo: this.formControl["telephone1"].value,
                            Email: this.formControl["emailaddress1"].value,
                            UserID: "",
                            CaseTypeId: this.formControl["dpa_casetypeid"].value,
                            CaseSubTypeId: this.formControl["dpa_casesubtypeid"].value,
                            subject: "",
                            CaseSubTypeDetailId: this.formControl["dpa_casesubtypedetailid"].value,
                            description: this.formControl["description"].value,
                            Channel: this.formControl["dpa_casechannelid"].value,
                            IdCard: this.formControl["dpa_idcard"].value
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "caseCaseChatBot", req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            if (res.Status != null && res.Status == "200") {
                                return [2 /*return*/, res.ticketnumber];
                            }
                            else {
                                //this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
                                return [2 /*return*/, null];
                            }
                        }
                        else {
                            //this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactDpaComponent.prototype.createContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var contactid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contactid = "";
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", this.form.value).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "") {
                                            contactid = res.contactid;
                                        }
                                        else {
                                            //this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ")
                                            return [2 /*return*/, null];
                                        }
                                    }
                                    else {
                                        return [2 /*return*/, null
                                            //this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ")
                                        ];
                                        //this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ")
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, contactid];
                }
            });
        });
    };
    ContactDpaComponent.prototype.telephoneOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (charCode == 35 || charCode == 44) {
                return true;
            }
            return false;
        }
        return true;
    };
    ContactDpaComponent.prototype.idCardValidator = function (control) {
        if (control.value && control.value.length == 13) {
            var total = 0;
            var iPID;
            var chk;
            var Validchk;
            iPID = control.value.replace(/-/g, "");
            Validchk = iPID.substr(12, 1);
            var j = 0;
            var pidcut;
            for (var n = 0; n < 12; n++) {
                pidcut = parseInt(iPID.substr(j, 1));
                total = (total + ((pidcut) * (13 - n)));
                j++;
            }
            chk = 11 - (total % 11);
            if (chk == 10) {
                chk = 0;
            }
            else if (chk == 11) {
                chk = 1;
            }
            if (chk == Validchk) {
                return null;
            }
            else {
                return { 'invalid IdCard': true };
            }
        }
        else {
            return null;
        }
    };
    ContactDpaComponent.prototype.mapDataToForm = function (data) {
        var _this = this;
        Object.keys(data).forEach(function (key) {
            if (_this.form.controls[key]) {
                _this.form.controls[key].setValue(data[key]);
            }
            else {
                _this.form.addControl(key, new FormControl(data[key]));
            }
        });
    };
    return ContactDpaComponent;
}());
export { ContactDpaComponent };



// WEBPACK FOOTER //
// ./src/app/contact-dpa/contact-dpa.component.ts.pre-build-optimizer.js